import {ref, onUnmounted} from 'vue';

export function usePolling(callback, interval = 60000) {
    const isPolling = ref(false);
    let timer = null;

    // Start polling
    const startPolling = () => {
        if (isPolling.value) return;

        isPolling.value = true;
        // Call the callback immediately
        callback();

        // Set up the interval
        timer = setInterval(() => {
            callback();
        }, interval);
    };

    // Stop polling
    const stopPolling = () => {
        if (!isPolling.value) return;

        clearInterval(timer);
        timer = null;
        isPolling.value = false;
    };

    // Clean up on component unmount
    onUnmounted(() => {
        stopPolling();
    });

    return {
        isPolling,
        startPolling,
        stopPolling
    };
}
